/* Native links remain usable without JavaScript. Enhancement adds accessible series tabs. */
if (!customElements.get('mr-product-model-finder')) {
  customElements.define('mr-product-model-finder', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.tabs = [...this.querySelectorAll('[data-model-tab]')];
      this.panels = [...this.querySelectorAll('[data-model-panel]')];
      if (!this.tabs.length) return;
      this.querySelector('[data-model-tabs]').setAttribute('role', 'tablist');
      this.tabs.forEach(tab => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', tab.getAttribute('href').slice(1));
      });
      this.panels.forEach(panel => { panel.setAttribute('role', 'tabpanel'); panel.tabIndex = 0; });
      const options = { signal: this.abort.signal };
      this.addEventListener('click', event => {
        const tab = event.target.closest('[data-model-tab]');
        if (!tab || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.select(tab);
      }, options);
      this.addEventListener('keydown', event => {
        const index = this.tabs.indexOf(event.target);
        if (index < 0 || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const rtl = getComputedStyle(this).direction === 'rtl';
        let next = event.key === 'Home' ? 0 : event.key === 'End' ? this.tabs.length - 1 :
          (index + (event.key === (rtl ? 'ArrowLeft' : 'ArrowRight') ? 1 : -1) + this.tabs.length) % this.tabs.length;
        this.select(this.tabs[next], true);
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const tab = this.tabs.find(tab => tab.dataset.blockId === event.detail.blockId);
        if (tab) this.select(tab);
      }, options);
      this.classList.add('is-enhanced');
      this.select(this.tabs.find(tab => tab.getAttribute('href') === '#' + this.dataset.initialPanel) || this.tabs[0]);
    }
    select(selected, focus = false) {
      const id = selected.getAttribute('href').slice(1);
      this.tabs.forEach(tab => {
        const active = tab === selected;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach(panel => { panel.hidden = panel.id !== id; });
      if (focus) selected.focus({ preventScroll: true });
      const list = selected.parentElement;
      // Only move the tab strip, never jump the whole product page on initialisation.
      const bounds = list.getBoundingClientRect(), tabBounds = selected.getBoundingClientRect();
      if (tabBounds.left < bounds.left) list.scrollLeft += tabBounds.left - bounds.left;
      else if (tabBounds.right > bounds.right) list.scrollLeft += tabBounds.right - bounds.right;
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}

/* A small disclosure keeps the header compact; its model cards open over the page. */
if (!customElements.get('mr-header-model-menu')) {
  customElements.define('mr-header-model-menu', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.details = this.querySelector('details');
      this.trigger = this.querySelector('summary');
      if (!this.details) return;
      const options = { signal: this.abort.signal };
      this.close = (restoreFocus = false) => {
        this.details.open = false;
        if (restoreFocus) this.trigger.focus({ preventScroll: true });
      };
      this.querySelector('[data-finder-close]')?.addEventListener('click', () => this.close(true), options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.details.open) {
          event.preventDefault(); event.stopPropagation(); this.close(true);
        }
      }, options);
      document.addEventListener('click', event => {
        if (this.details.open && !this.contains(event.target)) this.close();
      }, options);
      document.addEventListener('focusin', event => {
        if (this.details.open && !this.contains(event.target)) this.close();
      }, options);
      document.addEventListener('dialog:before-show', () => this.close(), { ...options, capture: true });
      if (typeof matchMedia === 'function') {
        matchMedia('(min-width: 1000px)').addEventListener('change', () => this.close(), options);
      }
      this.details.addEventListener('toggle', () => {
        if (!this.details.open) return;
        const finder = this.querySelector('mr-product-model-finder');
        const active = finder?.querySelector('[aria-selected="true"]');
        if (active && typeof finder.select === 'function') finder.select(active);
      }, options);
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
